import { render, staticRenderFns } from "./drag-column.vue?vue&type=template&id=416e6bf3&scoped=true"
import script from "./drag-column.vue?vue&type=script&lang=js"
export * from "./drag-column.vue?vue&type=script&lang=js"
import style0 from "./drag-column.vue?vue&type=style&index=0&id=416e6bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e6bf3",
  null
  
)

export default component.exports